import React, { Component } from "react";
import { Link } from "react-router-dom";
class AboutGDPR_SiteContent extends Component {
  render() {
    return (
      <div id="site-content" className="site-content clearfix">
        <div id="inner-content" className="inner-content-wrap">
          <div className="themesflat-headings style-2 clearfix">
            <h2 className="heading">GDPR</h2>
            <div className="sep has-width w80 accent-bg clearfix" />
            <p
              className="sub-heading font-size-16 line-height-28 text-666 margin-top-27 letter-spacing-01"
              style={{ textAlign: "justify" }}
            >
              ...
            </p>
          </div>
        </div>
        <div
          className="themesflat-spacer clearfix"
          data-desktop={80}
          data-mobile={60}
          data-smobile={60}
        />
      </div>
    );
  }
}

export default AboutGDPR_SiteContent;
